<template>
  <header class="top-bar">
    <div class="left">
      <div class="search">
        <input :placeholder="placeholder" :value="modelValue" @input="onInput" @keydown.enter="onEnter" />
        <button v-if="modelValue" type="button" class="clear-btn" @click="clearInput" aria-label="清除搜索内容">
          x
        </button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    placeholder?: string;
    modelValue?: string;
    searchHref?: string;
  }>(),
  {
    placeholder: "宗门里除了我全是卧底",
    modelValue: "",
    searchHref: "",
  }
);

const emit = defineEmits<{
  (event: "update:modelValue", value: string): void;
}>();

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
};

const onEnter = () => {
  if (!props.searchHref || !import.meta.client) return;
  window.location.href = props.searchHref;
};

const clearInput = () => {
  emit("update:modelValue", "");
};
</script>

<style scoped>
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: var(--app-header-height, 64px);
  box-sizing: border-box;
  padding: 12px 14px 10px;
  background: #fff;
  z-index: 100;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.logo-circle {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: #f3f5f7;
  color: #bbb;
  display: grid;
  place-items: center;
  font-size: 12px;
  border: 1px solid #e6e8ec;
}

.search {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f5f6f8;
  border-radius: 18px;
  padding: 8px 12px;
  border: 1px solid #e9ebef;
}

.search input {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
}

.icon {
  font-size: 14px;
  color: inherit;
  text-decoration: none;
}

:global(:root) {
  --app-header-height: 64px;
}

.clear-btn {
  border: none;
  background: transparent;
  color: #9aa0a6;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
}

.right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: url("https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=200&q=60") center/cover no-repeat;
}

.icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid #e6e8ec;
  display: grid;
  place-items: center;
  background: #fff;
  font-size: 15px;
}
</style>
